import { createRefresh } from 'react-auth-kit';
import API from './baseApi';

const refreshApi = createRefresh({
	interval: 58,
	refreshApiCallback: async ({ authToken, refreshToken }) => {
		try {
			const response = await API.post('/admin/refresh-tokens', { refreshToken });

			// Convert the expiration time to Date objects
			const accessTokenExpiration = new Date(response.data.access.expires);
			const refreshTokenExpiration = new Date(response.data.refresh.expires);

			// Calculate the difference in minutes from now to the expiration times
			const now = new Date();

			const accessTokenExpireInMinutes = Math.floor((accessTokenExpiration - now) / 60000);

			const refreshTokenExpireInMinutes = Math.floor((refreshTokenExpiration - now) / 60000);

			return {
				isSuccess: true,
				newAuthToken: response.data.access.token,
				newAuthTokenExpireIn: accessTokenExpireInMinutes,
				newRefreshToken: response.data.refresh.token,
				newRefreshTokenExpiresIn: refreshTokenExpireInMinutes,
			};
		} catch (error) {
			console.error(error);
			return {
				isSuccess: false,
			};
		}
	},
});

export default refreshApi;
